const DEFAULT_CURRENCY = 'DKK';
const TRACKING_DEBUG_QUERY_KEY = 'tracking_debug';
const TRACKING_DEBUG_STORAGE_KEY = 'theme:tracking:debug';
const TRACKING_DEBUG_STORAGE_KEY_LEGACY = 'theme:tracking_debug';

function isTrackingDebugEnabled() {
  try {
    const query = window.location.search || '';
    const hasDebugQuery = new RegExp(`(?:\\?|&)${TRACKING_DEBUG_QUERY_KEY}=1(?:&|$)`).test(query);

    if (hasDebugQuery) {
      return true;
    }

    const localStorageValue = window.localStorage?.getItem(TRACKING_DEBUG_STORAGE_KEY);
    const legacyLocalStorageValue = window.localStorage?.getItem(TRACKING_DEBUG_STORAGE_KEY_LEGACY);

    return localStorageValue === '1' || legacyLocalStorageValue === '1';
  } catch (error) {
    return false;
  }
}

function debugLog(...args) {
  if (!isTrackingDebugEnabled()) return;

  console.log('[theme-tracking]', ...args);
}

function debugWarn(...args) {
  if (!isTrackingDebugEnabled()) return;

  console.warn('[theme-tracking]', ...args);
}

function toNumber(value, fallback = 0) {
  const parsed = Number(value);

  return Number.isFinite(parsed) ? parsed : fallback;
}

function normalizeQuantity(quantity) {
  const parsedQuantity = parseInt(quantity, 10);

  return Number.isFinite(parsedQuantity) && parsedQuantity > 0 ? parsedQuantity : 1;
}

function normalizeCurrency() {
  const activeCurrency = window.Shopify?.currency?.active;

  if (typeof activeCurrency === 'string' && activeCurrency.length) {
    return activeCurrency;
  }

  const localeCurrency = window.Shopify?.locale?.currency;

  if (typeof localeCurrency === 'string' && localeCurrency.length) {
    return localeCurrency;
  }

  return DEFAULT_CURRENCY;
}

function customerCanBeTracked() {
  const privacyApi = window.Shopify?.customerPrivacy;

  if (!privacyApi) {
    return true;
  }

  if (typeof privacyApi.analyticsProcessingAllowed === 'function') {
    return privacyApi.analyticsProcessingAllowed();
  }

  if (typeof privacyApi.marketingAllowed === 'function') {
    return privacyApi.marketingAllowed();
  }

  return true;
}

function buildTrackingPayload(detail = {}) {
  const response = detail.response || {};
  const quantity = normalizeQuantity(detail.quantity);
  const unitPrice = toNumber(response.final_price || response.price, 0);
  const value = (unitPrice * quantity) / 100;
  const currency = normalizeCurrency();

  return {
    event: 'add_to_cart',
    value,
    currency,
    quantity,
    item: {
      item_id: String(response.product_id || ''),
      item_name: response.product_title || response.title || '',
      item_brand: response.vendor || '',
      item_variant: response.variant_title || '',
      item_category: response.product_type || '',
      price: unitPrice / 100,
      quantity,
      variant_id: String(response.variant_id || response.id || ''),
      sku: response.sku || '',
      product_handle: response.handle || '',
      product_url: response.url || '',
      image_url: response.featured_image?.url || '',
    },
  };
}

function trackMeta(payload) {
  if (typeof window.fbq !== 'function') {
    debugWarn('Skipped Meta dispatch - window.fbq is unavailable');
    return;
  }

  window.fbq('track', 'AddToCart', {
    content_ids: [payload.item.variant_id || payload.item.item_id],
    content_name: payload.item.item_name,
    content_type: 'product',
    value: payload.value,
    currency: payload.currency,
  });

  debugLog('Dispatched to Meta Pixel', {
    event: 'AddToCart',
    value: payload.value,
    currency: payload.currency,
    content_id: payload.item.variant_id || payload.item.item_id,
  });
}

function trackKlaviyo(payload) {
  if (!Array.isArray(window._learnq)) {
    debugWarn('Skipped Klaviyo dispatch - window._learnq is unavailable');
    return;
  }

  const klaviyoItem = {
    ProductName: payload.item.item_name,
    ProductID: payload.item.item_id,
    VariantID: payload.item.variant_id,
    SKU: payload.item.sku,
    Categories: payload.item.item_category ? [payload.item.item_category] : [],
    ImageURL: payload.item.image_url,
    URL: payload.item.product_url,
    Brand: payload.item.item_brand,
    Price: payload.item.price,
    Quantity: payload.quantity,
  };

  window._learnq.push(['track', 'Added to Cart', klaviyoItem]);
  debugLog('Dispatched to Klaviyo', {
    event: 'Added to Cart',
    ProductID: klaviyoItem.ProductID,
    VariantID: klaviyoItem.VariantID,
    Quantity: klaviyoItem.Quantity,
  });
}

function dispatchThemeTrackingEvent(payload) {
  document.dispatchEvent(
    new CustomEvent('theme:tracking:add-to-cart', {
      bubbles: true,
      detail: payload,
    })
  );
}

function onProductAdded(event) {
  const canTrack = customerCanBeTracked();
  debugLog('theme:product:add received', {
    canTrack,
    product_id: event?.detail?.response?.product_id,
    variant_id: event?.detail?.response?.variant_id || event?.detail?.response?.id,
    quantity: event?.detail?.quantity,
  });

  if (!canTrack) {
    debugWarn('Tracking blocked by privacy settings');
    return;
  }

  const payload = buildTrackingPayload(event.detail);
  debugLog('Built add_to_cart payload', payload);

  // Google/GA4 add_to_cart fjernet — h\u00e5ndteres nu af Google & YouTube-salgskanalen
  // for at undg\u00e5 dublerede add_to_cart-events i GA4/Ads.
  trackMeta(payload);
  trackKlaviyo(payload);
  dispatchThemeTrackingEvent(payload);
  debugLog('Dispatched internal event: theme:tracking:add-to-cart');
}

document.addEventListener('theme:product:add', onProductAdded);